import { Link, Outlet } from 'react-router';

import HelpIcon from '~/assets/icons/Help';
import SoleMarketplaceLogo from '~/assets/icons/SoleMarketplaceLogo';
import MarketplaceFooter from '~/legacy/components/footer/SoleMarketFooter';

export default function SoleMarketMenuTemplate() {
  return (
    <div className="flex min-h-screen flex-col justify-between">
      <Header />

      <Outlet />

      <MarketplaceFooter />
    </div>
  );
}

function Header() {
  return (
    <header className="h-12 w-full bg-black lg:h-16">
      <div className="content-width relative">
        <div className="flex h-12 w-full items-center justify-center bg-black lg:h-16 lg:justify-start">
          <Link to="/sole-market/">
            <>
              <span className="md:hidden">
                <SoleMarketplaceLogo fill="white" height="24" />
              </span>
              <span className="hidden md:block">
                <SoleMarketplaceLogo fill="white" height="36" width="192" />
              </span>
            </>
          </Link>
        </div>
        <a
          className="absolute inset-y-0 right-0 flex items-center lg:pr-4"
          href="https://thesolesupplier.zendesk.com/hc/en-gb"
        >
          <HelpIcon />
          <span className="pl-2 text-grey-hide lg:hidden">Help</span>
          <span className="hidden pl-2 text-grey-hide lg:inline">
            Need more help?
          </span>
        </a>
      </div>
    </header>
  );
}
